<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M28 14.952c0 6.049-5.373 10.952-12 10.952a12.94 12.94 0 01-4.864-.937.997.997 0 01-.112.072l-5.007 2.793a.965.965 0 01-.372.118.96.96 0 01-.61 0 1.017 1.017 0 01-.633-1.274l1.691-5.323a.95.95 0 01.058-.143C4.795 19.436 4 17.279 4 14.952 4 8.903 9.373 4 16 4s12 4.903 12 10.952zm-12 1.215a1.333 1.333 0 100-2.667 1.333 1.333 0 000 2.667zm6-1.334a1.333 1.333 0 11-2.667 0 1.333 1.333 0 012.667 0zm-10.667 1.334a1.333 1.333 0 100-2.667 1.333 1.333 0 000 2.667z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'communicationQuoteFilled'
}
</script>
